import React from 'react';
import PropTypes from 'prop-types';
import { Input, Row, Col } from 'antd';

const SocialInputItem = (props) => {
    const { Icon, icon_title, icon_class, title_class, type, input_class, container_class, placeholder, name, value, onChange } = props;

    return (
        <Row className={container_class}>
            <Col xs={8} sm={5} md={4} className="ori-bg-white ori-height-32 ori-border-default ori-tl-border-radius-5 ori-bl-border-radius-5 ori-flex-column ori-flex-jc ori-lr-pad-10 ori-r-border-none ori-bg-primary-light">
                <div className="ori-flex-row ori-overflow-hidden">
                    <Icon size={18} className={icon_class} />
                    <span className={`ori-full-flex ori-l-pad-5 ori-text-overflow-dotted ${title_class}`}>{icon_title}</span>
                </div>
            </Col>
            <Col xs={16} sm={19} md={20}>
                <Input type={type} placeholder={placeholder} className={input_class} name={name} value={value} onChange={onChange} />
            </Col>
        </Row>
    );
};

SocialInputItem.propTypes = {
    Icon: PropTypes.func,
    icon_class: PropTypes.string,
    icon_title: PropTypes.string,
    placeholder: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    title_class: PropTypes.string,
    input_class: PropTypes.string,
    container_class: PropTypes.string,
    type: PropTypes.string,
};

SocialInputItem.defaultProps = {
    input_class: "ori-tl-no-border-radius ori-bl-no-border-radius ori-font-xs",
    container_class: "ori-tb-pad-5",
    title_class: "ori-font-xs",
};

export default SocialInputItem;



// WEBPACK FOOTER //
// ./src/components/form/socialinputitem/index.js